export enum SdObjType {
  LIEFERANT = 'LIEFERANT',
  KUNDE = 'KUNDE',
  PROJEKT = 'PROJEKT',
}
